import { Typography } from "@mui/material";
import React from "react";

export const Pageheader = ({ headertitle, bgImage, isAbout, subTitle }) => {
	const HeaderTitle = headertitle;
	return (
		<div className="breadcrumb-area bg-overlay-2" style={{ position: "relative", overflow: "hidden" }}>
			{/* Background Image */}
			<img
				src={bgImage}
				alt="Background"
				style={{
					position: "absolute",
					top: 0,
					left: 0,
					width: "100%",
					height: "100%",
					objectFit: "cover",
					zIndex: isAbout ? 0 : -1,
				}}
			/>

			{/* Content */}
			<div className="container">
				<div className="breadcrumb-inner">
					<div className="section-title text-center">
						<Typography
							variant="h2"
							sx={{
								fontSize: "3rem",
								fontWeight: "800",
								fontFamily: 'Ibarra Real Nova',
								color: "#fff",
								textShadow: "0 4px 8px rgba(0, 0, 0, 0.5)",
								marginBottom: "20px",
								"@media (max-width: 600px)": {
									fontSize: "2rem",
								},
								"@media (max-width: 400px)": {
									fontSize: "1.6rem",
								},
							}}
						>
							{HeaderTitle}
						</Typography>
						{subTitle &&
							<Typography
								variant="body2"
								sx={{
									fontSize: "1rem",
									fontWeight: "800",
									fontFamily: 'Ibarra Real Nova',
									color: "#fff",
									textShadow: "0 4px 8px rgba(0, 0, 0, 0.5)",
									marginTop: "0px !important",
									marginBottom: "20px",
									"@media (max-width: 600px)": {
										fontSize: "2rem",
									},
									"@media (max-width: 400px)": {
										fontSize: "1.6rem",
									},
								}}>
								{subTitle}
							</Typography>}
					</div>
				</div>
			</div>
		</div>
	);
};

